import { Button, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { GetRommDetsName, RoomBoxColour } from "../../constants/pojoservice";
import DialogBox from "../../global/DialogBox";
import { BillingStatusGrid } from "./BillingStatusGrid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { RoomBillTableBtnClick } from "../../constants/Constants";

const RoomBillTableData = ({ dialog,
    newBookingAllowed,
    singleRoom,
    billingDataList,
    handleOnClick,
}) => {


    const renderBillingData = () => {
        return (
            <Grid container spacing={0.5}>
                <BillingStatusGrid />
                <Grid item xs={12}>
                    <TableContainer component={Paper} elevation={3} sx={{
                        maxHeight: 300,
                        overflowY: "auto",
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                        border: "none",
                        borderRadius: 2,
                    }}
                    >
                        <Table aria-label="extra-orders-table">
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: "#01333e",
                                    "& .MuiTableCell-root": {
                                        color: "#fff",
                                        fontWeight: "bold",
                                        fontSize: "0.8rem",
                                        padding: "6px 8px",
                                        borderBottom: "none",
                                    },
                                }}>
                                    <TableCell align="center">Actions</TableCell>
                                    <TableCell align="center">Invoice</TableCell>
                                    <TableCell align="center">Via</TableCell>
                                    <TableCell align="center">CheckIn</TableCell>
                                    <TableCell align="center">CheckOut</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {billingDataList.length === 0 ? (
                                    <TableRow>
                                        <TableCell align="center" colSpan={7}>
                                            <Typography variant="body2" color="text.secondary">
                                                No items yet. Add some above.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    billingDataList.map((r) => (
                                        <TableRow key={`${r.billId}::${r.bookingId}`} sx={{ backgroundColor: RoomBoxColour(r) }}>
                                            <TableCell align="center">
                                                <IconButton
                                                    size="small"
                                                    aria-label="edit"
                                                    onPointerDown={() => handleOnClick(RoomBillTableBtnClick.Existing_Booking_Click, r.billId, r.banquetBooking)}
                                                >
                                                    <VisibilityIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell align="center">{`${r.bookingId ?? ""}`}</TableCell>
                                            <TableCell align="center">{`${(r.banquetBooking ?? false) ? "Banquet" : "Room"}`}</TableCell>
                                            <TableCell align="center">{`${r.checkInDate ?? ""}`}</TableCell>
                                            <TableCell align="center">{`${r.checkoutDateStr ?? ""}`}</TableCell>
                                            <TableCell align="center">{`${r.billStatusId ?? ""}`}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        )
    };

    const renderAction = () => {
        return (
            <Stack direction="row" spacing={1} justifyContent="center">
                {
                    newBookingAllowed &&
                    <Button
                        size="small"
                        variant="contained"
                        onPointerDown={() => handleOnClick(RoomBillTableBtnClick.New_Booking_Click, singleRoom.id, false)}
                    >
                        New Booking
                    </Button>
                }
                <Button
                    size="small"
                    variant="outlined"
                    onPointerDown={() => handleOnClick(RoomBillTableBtnClick.No_Booking_Click, "", false)}
                >
                    Dismiss
                </Button>
            </Stack>
        )
    }

    return (
        <DialogBox
            showDialog={dialog}
            title={`${GetRommDetsName(1, singleRoom)} ${GetRommDetsName(3, singleRoom)}`}
            onClose={() => handleOnClick(RoomBillTableBtnClick.No_Booking_Click, "", false)}
            dialogContent={renderBillingData()}
            dialogActions={renderAction()}
        />
    )
};

export { RoomBillTableData };